module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/2-active-97125ececab32497c8269fd56c86d0e1.png";